import { createContext, h } from 'preact'

const HeaderImageContext = createContext([])

export const Context = HeaderImageContext

export const SiteHeaderImagesProvider = ({ images = [], children, ...rest } = {}) => (
  <HeaderImageContext.Provider value={images} {...rest}>
    {children}
  </HeaderImageContext.Provider>
)
